import { Component, Children } from 'react';
import PropTypes from 'prop-types';

const analyticsShape = PropTypes.shape({
  init: PropTypes.func.isRequired,
  track: PropTypes.func.isRequired,
});

export default class AnalyticsProvider extends Component {
  constructor(props, context) {
    super(props, context);
    this.analyticsService = props.analyticsService;
  }

  getChildContext() {
    return { analyticsService: this.analyticsService };
  }

  render() {
    const { children } = this.props;
    return Children.only(children);
  }
}

AnalyticsProvider.propTypes = {
  analyticsService: analyticsShape.isRequired,
  children: PropTypes.element.isRequired,
};

AnalyticsProvider.childContextTypes = {
  analyticsService: analyticsShape.isRequired,
};
